export enum FeedbackForFeature {
  Boards = `Boards`,
  Browse = `Search & Discover`,
  NewDropdowns2021 = `New Dropdowns 2021`,
  LiveviewEventInspector = `Liveview Event Inspector`,
  SidebarQB = `Query Panel`,
  General = `General`,
  FoundationalTemplates = `Foundational Templates`,
  OnboardingChecklist = `Onboarding Checklist`,
  StarterBoard = `Starter Board`,
}

export enum FeedbackType {
  Dealbreaker = `dealbreaker`,
  PainPoint = `pain_point`,
  Beta = `beta`,
  NotWorking = `not_working`,
}

export enum Sentiment {
  Positive = `positive`,
  Negative = `negative`,
}
